<template>
  <div class="ccui-tree-wrapper">
    <div class="dic-box">
      <span class="dic-left">{{ $t("page.content.navigation") }}</span>
    </div>
    <div class="ccui-tree">
      <el-tree
        style="width: 220px; margin-left: 20px;"
        class="parent-tree flow-tree"
        ref="tree"
        highlight-current
        :data="data"
        :props="defaultProps"
        node-key="faqId"
        :check-strictly="true"
        :default-expanded-keys="expendedIdArr"
        @node-click="nodeClick"
      >
        <div
          :class="{
            'level-one': node.level == 1,
            'level-two': node.level == 2,
            ellipsis: true
          }"
          slot-scope="{ node }"
        >
          <span :title="node.label">
            {{ node.label }}
          </span>
        </div>
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  name: "slideTree",
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "label"
      },
      expendedIdArr: [1]
    };
  },
  methods: {
    nodeClick(obj, node) {
      if (node.isLeaf && !obj.isParent) {
        this.$emit("handleNodeClick", obj);
      }
    }
  }
};
</script>

<style></style>
